export const HomeDEScript =
{
  "@context": "https://schema.org",
  "@type": "ItemList",
  "url": "https://www.akky.mx/",
  "numberOfItems": "4",
  "itemListElement": []
};
